<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <transition name="title">
          <div v-if="tickets.length === 1" class="title">Ingresso</div>
          <div v-if="tickets.length > 1 && !billetRefund" class="title">Ingressos {{ position + 1 }} de {{ tickets.length }}</div>
          <div v-if="billetRefund" class="title">Estorno bancário</div>
        </transition>
        <div @click="close" class="close"><i class="fas fa-times"></i></div>
      </div>
      <transition name="page" style="overflow-y:scroll !important;">
        <div v-if="loading" key="loading">
          <i class="fas fa-spinner loading-big"></i>
        </div>
        <div v-if="!loading" class="printable" key="ticket">
          <div class="actions top-btn" v-if="!loading && showData.show.type !== 'Curso' && !isCancel && !isTransfer">
            <button @click="callCancel" v-if="ticket && ticket.valid && !ticket.userTransfer && ticket.tiketera && ticket.paymentMethod != 'billet'" class="button-save"><i class="far fa-trash-alt"></i><span>Cancelar o Ingresso</span></button>
            <!--<button @click="callTransfer" class="button-save"><i class="fas fa-random"></i><span>Transferir Titularidade</span></button>-->
          </div>
          <!--CANCELAR INGRESSO-->
          <div v-if="isCancel && !billetRefund" class="form" style="margin-top:-10px;">
            <h3 class="cancel-text">Você realmente deseja cancelar esse ingresso?</h3>
            <label class="switch">
              <input v-model="checkCancel" type="checkbox">
              <span class="slider"></span>
              <span class="text">Estou ciente que de acordo com o Código de Defesa do Consumidor, ao solicitar o cancelamento do ingresso, a devolução do valor não será integral, sendo retida a taxa de serviço.</span>
            </label>
            <div class="actions top-btn" style="margin-top:20px;">
              <button @click="callCancel" class="button-save"><i class="fas fa-hand-point-left"></i><span>Voltar</span></button>
              <button @click="cancelTicket" class="button-save"><i class="fas fa-check-circle"></i><span>Sim, desejo cancelar</span></button>
            </div>
          </div>
          <!--CANCELAR INGRESSO PAGO POR BOLETO-->
          <div v-if="isCancel && checkCancel && billetRefund">
            <div class="print-text" style="margin-top:-20px;text-align:justify;font-size: 10pt;font-family:'Draft B';padding: 0 15px;">Preencha CORRETAMENTE os campos abaixo com seus dados bancário e clique no botão <strong>Solicitar Estorno</strong> para receber o estorno em sua conta bancária.</div>
            <form class="form" style="display:list-item">
              <label>Código do Banco</label>
              <select v-model="bankCode" style="width: 100%">
                <option v-for="item in banks" :key="item.bankId" :value="item.bankId">
                  {{ item.bankDesc }}
                </option>
              </select>
              <div v-if="error.includes('bankCode')" class="hint">Código de banco inválido</div>
              <div style="width: 160px;margin:5px 0px;">
                <label>Número da agência</label>
                <input v-model="agency" type="text" placeholder="Número da agência" style="width: 160px"/>
                <div v-if="error.includes('agency')" class="hint">Agência inválida</div>
              </div>
              <div style="float:right !important;width: 160px;margin:-50px 0 0 2px;">
                <label>Dígito da agência</label>
                <input v-model="agency_dg" type="text" placeholder="Dígito da agência" style="width: 160px"/>
                <div v-if="error.includes('agency_dg')" class="hint">Dígito inválido</div>
              </div>
              <div style="width: 160px;margin:5px 0px;">
                <label>Número da conta</label>
                <input v-model="account" type="text" placeholder="Número da conta" style="width: 160px"/>
                <div v-if="error.includes('account')" class="hint">Conta inválida</div>
              </div>
              <div style="float:right !important;width: 160px;margin:-50px 0 0 2px;">
                <label>Dígito da conta</label>
                <input v-model="account_dg" type="text" placeholder="Dígito da conta" style="width: 160px"/>
                <div v-if="error.includes('account_dg')" class="hint">Dígito inválido</div>
              </div>
              <div style="width: 160px;margin:5px 0px;">
                <label>Tipo de conta</label>
                <select v-model="account_type" style="width: 160px">
                  <option value="conta_corrente">Conta Corrente</option>
                  <option value="conta_poupanca">Conta Poupança</option>
                </select>
                <div v-if="error.includes('account_type')" class="hint">Tipo inválido</div>
              </div>
              <div style="float:right !important;width: 160px;margin:-50px 0 0 2px;">
                <label>CPF ou CNPJ</label>
                <input v-model="document" type="text" placeholder="CPF ou CNPJ" style="width: 160px"/>
                <div v-if="error.includes('document')" class="hint">Documento inválido</div>
              </div>
              <div style="width: 100%">
                <label>Nome do favorecido</label>
                <input v-model="name" type="text" placeholder="Nome do favorecido" style="width: 100%"/>
                <div v-if="error.includes('name')" class="hint">Nome inválido</div>
              </div>
              <div style="text-align:center;margin-top:20px;font-size: 12pt;">
                <button @click="callRefund" class="button-save"><span>Solicitar Estorno</span></button>
              </div>
            </form>
          </div>
          <!--TRANSFERIR INGRESSO-->
          <div v-if="isTransfer && !billetRefund" class="form" style="margin-top:-20px;">
            <label>Digite o email da pessoa com cadastro na Tiketera</label>
            <input v-model="emailTransfer" type="email" placeholder="Email a ser transferido" style="text-transform: lowercase;"/>
            <h4>Esse ingresso será transferido para a pessoa e não aparecerá mais em seus ingressos</h4>
            <div class="actions top-btn" style="margin-top:20px;">
              <button @click="callTransfer" class="button-save"><i class="fas fa-hand-point-left"></i><span>Voltar</span></button>
              <button @click="transferTicket" class="button-save"><i class="fas fa-random"></i><span>Transferir para esse email</span></button>
            </div>
            <div v-if="shareTransfer && isTransfer" class="actions top-btn" style="margin-top:10px;">
              <button @click="sendMailTransfer" class="button-save"><i class="far fa-envelope"></i><span>Enviar email convidando para realizar o cadastro</span></button>
            </div>
          </div>
          <div v-if="!isTransfer && !isCancel">
            <div class="print-text" style="font-size: 10pt; font-weight: 300">{{ business.name }}</div>
            <div class="print-text" style="font-size: 12pt; font-weight: bold">{{ showData.show.name }}</div>
            <div class="print-text" style="font-size: 10pt">{{ getDate(showData.showDate.date) }} {{ getTimeMin(showData.showDate.date) }}</div>
            <div class="print-space"></div>
            <div v-if="showData.show.type !=='Curso'">
              <div class="print-text" style="font-size: 24pt">{{ ticket.seat }}</div>
              <div v-if="!showData.showDate.withSection" class="print-text" style="font-size: 10pt">{{ ticket.ticketType }} | R$ {{ ticket.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div v-else class="print-text" style="font-size: 10pt"><b>{{ ticket.section ? ticket.section.replace(/_/g, " ") + " - " : '' }}</b> {{ ticket.ticketType }} | R$ {{ ticket.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
              <div class="print-text" style="font-size: 10pt; font-weight: 300">{{ ticket.name }}</div>
              <div class="print-space"></div>
              <div class="print-qrcode">
                <img :src="`${API}/barcode/${ticket.key}`" />
              </div>
            </div>
            <div v-else>
              <div style="margin:20px; font-size: 10pt">
                Olá <b>{{ ticket.name }}</b>!
                Seu ingresso para o curso <b>{{ showData.show.name }}</b> que acontecerá em <b>{{ getDate(showData.showDate.date) }} às {{ getTimeMin(showData.showDate.date) }}</b> já está confirmado. <br>
                <br>
                <br>
                Bom curso!
              </div>
            </div>
          </div>
          <!-- <div class="print-space"></div>
          <div class="print-text">{{ business.nameReal }}</div>
          <div class="print-text">{{ business.regDocument }}</div>
          <div class="print-text">{{ business.addressStreet }}, {{ business.addressNumber }}</div>
          <div class="print-text">{{ business.addressCity }} - {{ business.addressState }} - {{ business.addressPostcode }}</div> -->
        </div>
      </transition>
      <div class="actions" v-if="!loading && showData.show.type !== 'Curso' && !isTransfer && !isCancel">
        <button @click="prevTicket" class="button-previous"><i class="fas fa-angle-left"></i></button>
        <button @click="nextTicket" class="button-previous button-previous-next" ><i class="fas fa-angle-right"></i></button>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { getByTransaction, cancelTicket, transferTicket, getBanks, refundBillet } from '../../main/api/ticket'
import { get as getShowDate } from '../../main/api/showDate'
import { get as getBusiness } from '../../main/api/business'
import { mailInvite } from '../../main/api/mail'

export default {
  name: 'userTicket',
  props: ['transaction', 'showDate', 'close'],
  data () {
    return {
      API: process.env.VUE_APP_API,
      loading: true,
      position: 0,
      tickets: [],
      showData: null,
      business: null,
      ticket: null,
      printing: false,
      isTransfer: false,
      emailTransfer: '',
      isCancel: false,
      checkCancel: false,
      shareTransfer: false,
      billetRefund: false,
      banks: [],
      bankCode: '',
      agency: '',
      agency_dg: '',
      account: '',
      account_dg: '',
      account_type: '',
      document: '',
      name: '',
      error: []
    }
  },
  async mounted () {
    try {
      const results = await Promise.all([
        getByTransaction(this.transaction),
        getShowDate(this.showDate)
      ])
      this.showData = results[1]
      if (this.showData.showDate.withoutStage) {
        this.tickets = results[0].filter(x => x.status === 'paid').sort((a, b) => a.id - b.id)
      } else {
        this.tickets = results[0].filter(x => x.status === 'paid').sort((a, b) => a.seat ? a.seat.localeCompare(b.seat, 'en', { numeric: true }) : '')
      }
      this.business = await getBusiness(this.showData.show.business)
      this.ticket = this.tickets[0]
    } catch (error) {
      logger.error(error, this)
    }
    this.loading = false
  },
  methods: {
    sendMailTransfer () {
      mailInvite(this.ticket.id, this.emailTransfer)
      this.$message.success('Convite de cadastro enviado para o email', { duration: 3000 })
      this.shareTransfer = false
    },
    callCancel () {
      this.isTransfer = false
      this.isCancel = !this.isCancel
      this.shareTransfer = false
    },
    callTransfer () {
      this.isCancel = false
      this.isTransfer = !this.isTransfer
      this.shareTransfer = false
    },
    async callRefund () {
      // Clean errors
      this.error = []
      this.loading = true
      try {
        await refundBillet(
          String(this.bankCode),
          String(this.agency),
          String(this.agency_dg),
          String(this.account),
          String(this.account_dg),
          String(this.account_type),
          String(this.document),
          this.name,
          this.ticket.id,
          this.ticket.price
        )
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else if (data.error === 'Too many attemps') {
          this.error = ['blocked']
        } else {
          this.error = ['internal']
          logger.error(error, this)
        }
      }
      this.loading = false
    },
    async cancelTicket () {
      if (!this.checkCancel) {
        this.$message.error('Marque a opção que esta ciente do cancelamento.', { duration: 3000 })
      } else {
        if (this.ticket.paymentMethod === 'billet') {
          this.loading = true
          this.billetRefund = true
          try {
            this.banks = await getBanks()
          } catch (error) {
            logger.error(error, this)
          }
          this.loading = false
        } else {
          this.loading = true
          try {
            await cancelTicket(this.ticket.id, this.ticket.price)
            this.$message.success('O ingresso foi cancelado', { duration: 3000 })
            this.tickets.splice(1, this.position)
            setTimeout(() => {
              this.$router.go()
            }, 500)
          } catch (error) {
            this.$message.error('Não foi possível cancelar o ingresso', { duration: 3000 })
          } finally {
            this.loading = false
          }
        }
      }
    },
    async transferTicket () {
      if (!this.emailTransfer) {
        this.$message.error('Informe o email a ser transferido.', { duration: 3000 })
      } else {
        try {
          this.loading = true
          const result = await transferTicket(this.ticket.id, this.emailTransfer)
          if (result && !result.error) {
            this.$message.success('O ingresso foi transferido', { duration: 3000 })
            this.tickets.splice(1, this.position)
            setTimeout(() => {
              this.$router.go()
            }, 500)
          } else {
            this.$message.error('Não foi possível transferir o ingresso', { duration: 3000 })
          }
          this.loading = false
        } catch (error) {
          const data = error.response ? error.response.data : {}
          if (data.error === 'User transfer not found') {
            this.$message.error('Esse email não tem cadastro na Tiketera', { duration: 3000 })
            this.shareTransfer = true
            this.loading = false
          }
        }
      }
    },
    nextTicket () {
      if (this.position === this.tickets.length - 1) return false
      this.position = this.position + 1
      this.ticket = this.tickets[this.position]
    },
    prevTicket () {
      if (this.position === 0) return false
      this.position = this.position - 1
      this.ticket = this.tickets[this.position]
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.top-btn {
  font-size: 9pt;
  font-weight: 400;
  margin: -20px 10px 20px 10px;
}
.btn-transfer {
  width: 120px !important;
  font-size: 10pt !important;
  font-weight: 400;
  margin:10px 0 20px 33%;
}
.btn-cancel {
  width: 190px !important;
  font-size: 10pt !important;
  font-weight: 400;
  margin:10px 0 20px 25%;
}
.cancel-text {
  text-align: center;
  font-size: 10pt !important;
}
.button-wallet {
  width: auto;
  height: 40px;
}

.box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.printable {
  font: 7pt sans-serif;
  line-height: 1.3;
  margin: 15px 0;
  padding: 0;
  color: #000000;
}

.print-text {
  text-align: center;
}

.print-space {
  height: 20px;
}

.print-qrcode {
  text-align: center;
  img {
    display: block;
    max-width: 150px;
    height: auto;
    margin: 0 auto;
  }
}

.button-print {
  display: none;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .button-print {
    display: block;
  }
}
</style>
